<template>
    <ValidationObserver v-slot="{ handleSubmit, invalid }">
        <b-form @submit.prevent="handleSubmit(createPriceList)">  
            <b-card header-tag="header" footer-tag="footer" class="mt-8 mb-8">
                <template v-slot:header>
                    <p class="mb-0" style="font-size: 21px">Registrar Item</p>
                </template>
                <b-card-text>
                    <b-alert show variant="danger" v-if="errors">
                        <ul >
                            <li v-for="(item, index) in errors" :key="index">{{ item }}</li>
                        </ul>
                    </b-alert>
                    <b-row>        
                        <b-col cols="12" md="4">
                            <ValidationProvider name="codigo" rules="required"  v-slot="{ errors, valid }">
                                <b-form-group prepend="SL"
                                    label="Código:">
                                    <b-input-group class="mb-2 mr-sm-2 mb-sm-0">
                                        <template #prepend>
                                            <b-input-group-text >SL</b-input-group-text>
                                        </template>
                                        <b-form-input
                                            v-model="create.codigo"
                                            type="text"
                                            autocomplete="off"
                                            required
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            placeholder="Ingrese el código"
                                        ></b-form-input>
                                        <b-form-invalid-feedback>
                                            {{ errors[0] }}
                                        </b-form-invalid-feedback>
                                    </b-input-group>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="4">
                            <ValidationProvider name="nombre" rules="required|min:3" v-slot="{ errors, valid }">
                                <b-form-group 
                                    label="Nombre:">
                                    <b-form-input
                                        v-model="create.nombre"
                                        type="text"
                                        autocomplete="off"
                                        required
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        placeholder="Ingrese el nombre"
                                        ></b-form-input>
                                    <b-form-invalid-feedback>
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="4">
                            <ValidationProvider name="categoria" rules="required" v-slot="{ errors, valid }">
                                <b-form-group 
                                    label="Selecciona categoria:">
                                    <b-form-select
                                        v-model="create.categoria_id"
                                        :options="categoriesList"
                                        class="mb-3"
                                        value-field="id"
                                        text-field="nombre"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        >
                                    </b-form-select>
                                    <b-form-invalid-feedback>
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="4">
                            <b-form-group 
                                label="Imagen:">
                                <b-form-file
                                    v-model="imagen"
                                    :state="Boolean(imagen)"
                                    browse-text="Buscar"
                                    accept="image/*"
                                    placeholder="Selecciona una imagen"
                                    drop-placeholder="Arrastre una imagen aqui"
                                ></b-form-file>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="4">
                            <ValidationProvider name="precio" rules="required|numeric" v-slot="{ errors, valid }">
                                <b-form-group 
                                    label="Precio:">
                                    <b-form-input
                                        v-model="create.precio"
                                        type="number"
                                        autocomplete="off"
                                        required
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        placeholder="Ingrese el precio"
                                        ></b-form-input>
                                    <b-form-invalid-feedback>
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="4">
                            <ValidationProvider name="Impuesto" rules="required|min:1|max:2" v-slot="{ errors, valid }">
                                <b-form-group prepend="%"
                                    label="Porcentaje Impuesto:">
                                    <b-form-input
                                        v-model="create.porcentaje_impuesto"
                                        type="number"
                                        autocomplete="off"
                                        required
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        placeholder="Ingrese el porcentaje de impuesto"
                                        ></b-form-input>
                                    <b-form-invalid-feedback>
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="4">
                            <ValidationProvider name="código de barras" v-slot="{ errors, valid }">
                                <b-form-group 
                                    label="Código de Barras:">
                                    <b-form-input
                                        v-model="create.codigo_barras"
                                        type="text"
                                        autocomplete="off"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        placeholder="Ingrese el código de barras"
                                        ></b-form-input>
                                    <b-form-invalid-feedback>
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="4" v-if="opcionExistencia === 1">
                            <ValidationProvider name="Existencia" rules="numeric" v-slot="{ errors, valid }">
                                <b-form-group 
                                    label="Existencia:">
                                    <b-form-input
                                        v-model="create.existencia"
                                        type="number"
                                        autocomplete="off"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        placeholder="Ingrese la cantidad de existencia"
                                        ></b-form-input>
                                    <b-form-invalid-feedback>
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="12">
                            <VueEditor v-model="create.descripcion"></VueEditor>
                        </b-col>
                    </b-row>
                </b-card-text>
                <template v-slot:footer>
                    <b-button variant="danger" class="mr-2" @click.prevent="back">
                        Cancelar
                    </b-button>
                    <b-button variant="success" :disabled="invalid" type="submit">
                        Registrar
                    </b-button>
                </template>
            </b-card>
        </b-form>
    </ValidationObserver>
    
</template>

<script>
import { VueEditor } from 'vue2-editor'
import { mapMutations } from 'vuex'
export default {
    data(){
        return{
            errors: "",
            create: {
                codigo: '',
                nombre: '',
                categoria_id: '',
                status: true
            },
            categoriesList: [],
            imagen: null,
            opcionExistencia: "",
        }
    },
    components: {
        VueEditor
    },
    created(){
        this.getCategoriesList();
        this.getConfiguracion();
    },
    methods:{
        ...mapMutations(['setLoading']),
        async createPriceList(){
            this.setLoading(true)
            this.errors = "";
            let formData = new FormData();
            formData.append('imagen', this.imagen);
            for(let element in this.create){
                if(this.create[element] !== 'undefined'){
                    formData.append(element, this.create[element]);
                }
            }
            await this.$conectar.post('/empresa/items/save-item-inventory', formData, {
                headers: {
                'Content-Type': 'multipart/form-data'
                }
            })
            .then(response =>{
                if(response.data.errors){
                    this.errors = response.data.errors;
                }
                if(response.data.error === false){
                    this.$root.$bvToast.toast('Se guardo correctamente el item', {
                            title: "Respuesta del servidor",
                            variant: "success",
                            solid: true
                    })
                    this.$router.push({ name: 'GetItemsListEmpresa' });
                }
            })
            .catch(e => {
                console.log(e.response);
                this.$bvToast.toast('Parece que hubo un error en el servidor', {
                    title: "Respuesta del servidor",
                    variant: "danger",
                    solid: true
                })
            })
            this.setLoading(false)
        },
        back(){
            this.$router.go(-1);
        },
        async getConfiguracion(){
            this.setLoading(true)
            await this.$conectar.post('configuracion/get-configuration')
            .then(response =>{
                if(response.data.error == false){
                    this.opcionExistencia = response.data.configuracion.opcionExistencia;
                }
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        async getCategoriesList(){
            this.setLoading(true)
            await this.$conectar.post('/empresa/items/get-available-categories-list')
            .then(response =>{
                this.categoriesList = response.data.availableCategoriesList;
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },

        
    }
}
</script>